import { useAppSelector } from '../useAppSelector';
import * as lookupSlice from '../../data/lookup.slice';

export const useGender = (genderCode: string | undefined): string => {
  const genders = useAppSelector(lookupSlice.selectGenders);
  const gender = genders.find((g) => g.genderCode === genderCode);
  return gender ? gender.genderName : '';
};
